const takeoutComponentLoaders = Object.freeze({
  'takeout.public-request': async () => {
    const module = await import('./takeout-workspace-components.js');
    return module.PublicTakeoutRequestComponent;
  },
  'takeout.operations-workspace': async () => {
    const module = await import('./takeout-workspace-components.js');
    return module.TakeoutOperationsWorkspaceComponent;
  },
});

export default takeoutComponentLoaders;
